import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Home from '~/pages/Home'
import Support from '~/pages/Support'

function App() {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/support" element={<Support />} />
            </Routes>
        </Router>
    )
}

export default App
